<template>
        <div
          v-if="(a.requiredCardsBlock7.length )"
          class="required-block required-block-7 mb-1 attachments-block-collapse-wrapper"
        >
          <b-button
            variant="link"
            @click="a.checkThemAll(7)"
          >
            <h6 class="required-block-title">
              <feather-icon
              :icon="a.show_attachments_block7 ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              size="16"
              class="mr-1"
            />
              مرفقات و صور من الطبيعة (المعاينة)
            </h6>
          </b-button>
          <b-collapse v-model="a.show_attachments_block7">

            <team-editor-card type="inspection" />

            <div class="d-flex flex-wrap required-block-cards">
              <template v-for="card in a.requiredCardsBlock7">
                <!-- Multiple files display for "ارفاق متعدد صور توضيحية للمكتب الفني" -->
                <div
                  v-if="card.key === 'ارفاق متعدد صور توضيحية للمكتب الفني' && card.isMultiple"
                  :key="`multiple-${card.key}`"
                  class="w-100 mb-3"
                >
                  <b-card class="shadow-sm">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <h6 class="mb-0">
                        {{ card.key }}
                      </h6>
                      <b-badge variant="info">
                        {{ card.files_count }} ملف
                      </b-badge>
                    </div>
  
                    <!-- Upload Section -->
                    <div class="mb-3">
                      <div class="d-flex align-items-center gap-1">
                        <b-form-file
                          v-model="a.requiredUploads[card.key]"
                          :disabled="a.isUploadDisabledByTeam(card.key)"
                          :state="Boolean(a.requiredUploads[card.key])"
                          placeholder="اختر ملف أو أكثر"
                          drop-placeholder="اسحب الملفات هنا"
                          browse-text="تصفح"
                          multiple
                          :accept="a.getAcceptExtensions(card.key)"
                          class="flex-grow-1 mb-0"
                        />
                        <b-button
                          v-b-tooltip.hover.top="'إضافة ملفات'"
                          size="sm"
                          variant="primary"
                          class="flex-shrink-0"
                          :disabled="a.isUploadDisabledByTeam(card.key) || !a.requiredUploads[card.key] || a.isUploadingRequired(card.key)"
                          @click="a.submitRequiredMultiple(card.key)"
                        >
                          <b-spinner v-if="a.isUploadingRequired(card.key)" small />
                          <feather-icon v-else icon="UploadIcon" size="12" />
                        </b-button>
                      </div>
                      <small
                        v-if="a.isUploadDisabledByTeam(card.key)"
                        class="text-danger d-block mt-1"
                      >يجب اضافة الفريق اولا</small>
                    </div>
  
                    <!-- Files List -->
                    <div
                      v-if="card.files && card.files.length > 0"
                      class="files-list d-flex flex-wrap"
                    >
                      <b-card
                        v-for="file in card.files"
                        :key="file.id"
                        class="media-card mb-2 shadow-sm"
                        body-class="p-1 d-flex flex-column align-items-center"
                      >
                        <!-- Collection checkbox for projectType 168 -->
                        <div
                          v-if="a.isProject168"
                          class="media-select-checkbox"
                        >
                          <b-form-checkbox
                            :checked="a.isCollectionSelected(file)"
                            @change="a.onCollectionCheckboxChange(file, $event)"
                          />
                        </div>
  
                        <!-- File preview -->
                        <div class="media-card-thumb mb-1">
                          <img
                            v-if="file.is_image"
                            :src="file.url"
                            alt="preview"
                            class="media-thumb-img"
                          >
                          <div v-else-if="file.is_document && file.extension === 'pdf'">
                            <b-icon
                              icon="file-earmark-pdf"
                              variant="danger"
                              font-scale="3.2"
                              class="my-3"
                            />
                          </div>
                          <div v-else-if="file.is_video">
                            <b-icon
                              icon="camera-video"
                              variant="primary"
                              font-scale="3.2"
                              class="my-3"
                            />
                          </div>
                          <div v-else>
                            <b-icon
                              icon="file-earmark"
                              variant="secondary"
                              font-scale="3.2"
                              class="my-3"
                            />
                          </div>
                        </div>
  
                        <div class="media-file-details w-100 text-center mb-1">
                          <div
                            class="file-title"
                            style="word-break:break-all"
                          >
                            {{ file.file_name || file.name }}
                          </div>
                          <div class="file-meta text-muted small mt-1">
                            {{ (file.extension || '').toUpperCase() }} • {{ file.human_readable_size }}
                          </div>
                          <div class="file-meta text-muted small mt-1">
                            {{ file.uploader ? file.uploader.name : '' }}
                          </div>
                          <div class="file-meta text-muted small mt-1">
                            {{ file.created_at | formatJalali }}
                          </div>
                        </div>
  
                        <!-- Notes Section -->
                        <div class="media-card-notes w-100 ">
                          <div
                            v-if="!a.editingNotes[file.id]"
                            class="notes-display"
                          >
                            <div
                              v-if="file.notes"
                              class="notes-content"
                            >
                              <p class="notes-text mb-0">
                                {{ file.notes }}
                              </p>
                            </div>
                          </div>
                          <div
                            v-else
                            class="notes-edit"
                          >
                            <b-form-textarea
                              v-model="a.notesEdit[file.id]"
                              placeholder="أدخل الملاحظات..."
                              rows="3"
                              class=""
                              :disabled="a.savingNotes[file.id]"
                            />
                            <div class="d-flex gap-1">
                              <b-button
                                size="sm"
                                variant="primary"
                                class="flex-fill"
                                :disabled="a.savingNotes[file.id]"
                                @click="a.saveNote(file)"
                              >
                                <b-spinner
                                  v-if="a.savingNotes[file.id]"
                                  small
                                  class="mr-1"
                                />
                                حفظ
                              </b-button>
                              <b-button
                                size="sm"
                                variant="outline-secondary"
                                class="flex-fill"
                                :disabled="a.savingNotes[file.id]"
                                @click="a.cancelEditingNote(file.id)"
                              >
                                إلغاء
                              </b-button>
                            </div>
                          </div>
                        </div>
  
                        <!-- File Actions -->
                        <div class="media-card-actions d-flex flex-row justify-content-center gap-1 w-100">
                          <b-button
                            v-if="file.is_image || file.is_video || file.is_document"
                            v-b-tooltip.hover.top="'معاينة'"
                            :href="file.url"
                            target="_blank"
                            size="sm"
                            class="btnSM"
                            variant="info"
                          >
                            <feather-icon icon="EyeIcon" size="12" />
                          </b-button>
                          <b-button
                            v-if="a.hasPermission('download media')"
                            v-b-tooltip.hover.top="'تحميل'"
                            :href="file.download_url"
                            target="_blank"
                            size="sm"
                            class="btnSM"
                            variant="success"
                          >
                            <feather-icon icon="DownloadIcon" size="12" />
                          </b-button>
                          <b-button
                            v-if="file.download_PDF_url && a.hasPermission('download media')"
                            v-b-tooltip.hover.top="'PDF تحميل'"
                            :href="file.download_PDF_url"
                            target="_blank"
                            size="sm"
                            class="btnSM"
                            variant="primary"
                          >
                            <feather-icon icon="DownloadCloudIcon" size="12" />
                          </b-button>
                          <b-button
                            v-if="a.hasPermission('delete media')"
                            v-b-tooltip.hover.top="'حذف'"
                            size="sm"
                            class="btnSM"
                            variant="danger"
                            @click="a.deleteFile(file.id)"
                          >
                            <feather-icon icon="Trash2Icon" size="12" />
                          </b-button>
                          <b-button
                            v-if="!a.editingNotes[file.id] && a.hasPermission('edit projects')"
                            v-b-tooltip.hover.top="file.notes ? 'تعديل الملاحظات' : 'إضافة ملاحظات'"
                            size="sm"
                            class="btnSM"
                            variant="outline-secondary"
                            @click="a.startEditingNote(file)"
                          >
                            <feather-icon icon="EditIcon" size="12" />
                          </b-button>
                        </div>
                      </b-card>
                    </div>
                  </b-card>
                </div>
                <!-- Single file display for other cards -->
                <b-card
                  v-else
                  :key="`required-${card.key}`"
                  :class="['media-card mb-2 shadow-sm', { 'cad-ark-card': card.key === 'ملف CAD من الارك' }]"
                  body-class="p-1 d-flex flex-column align-items-center"
                  
                >
                  <div
                    v-if="a.isProject168 && card.file"
                    class="media-select-checkbox"
                  >
                    <b-form-checkbox
                      :checked="a.isCollectionSelected(card.file)"
                      @change="a.onCollectionCheckboxChange(card.file, $event)"
                    />
                  </div>
                  <div class="w-100 text-center ">
                    <div
                      class="file-title font-weight-bold"
                      style="word-break:break-word"
                    >
                      {{ card.key }}
                    </div>
                  </div>
                  <div class="media-file-details w-100 text-center ">
                    <template v-if="card.file">
                      <div class="file-meta text-muted small ">
                        {{ (card.file.extension || '').toUpperCase() }} • {{ card.file.human_readable_size }}
                      </div>
                      <div class="file-meta text-muted small ">
                        <br>{{ card.file.uploader ? card.file.uploader.name : '' }}
                      </div>
                      <div class="file-meta text-muted small ">
                        {{ card.file.created_at | formatJalali }}
                      </div>
                    </template>
                    <template v-else>
                      <div class="text-muted small ">
                        غير موجود
                      </div>
                    </template>
                  </div>
                  <div class="w-100 mt-1">
                    <div class="d-flex align-items-center gap-1">
                      <b-form-file
                        v-model="a.requiredUploads[card.key]"
                        :disabled="a.isUploadDisabledByTeam(card.key)"
                        :state="Boolean(a.requiredUploads[card.key])"
                        placeholder="اختر ملف"
                        drop-placeholder="اسحب الملف هنا"
                        browse-text="تصفح"
                        :accept="a.getAcceptExtensions(card.key)"
                        class="flex-grow-1 mb-0"
                      />
                      <b-button
                        v-b-tooltip.hover.top="card.file ? 'تحديث' : 'رفع'"
                        size="sm"
                        variant="primary"
                        class="flex-shrink-0"
                        :disabled="a.isUploadDisabledByTeam(card.key) || !a.requiredUploads[card.key] || a.isUploadingRequired(card.key)"
                        @click="a.submitRequired(card.key)"
                      >
                        <b-spinner
                          v-if="a.isUploadingRequired(card.key)"
                          small
                        />
                        <feather-icon
                          v-else
                          icon="UploadIcon"
                          size="12"
                        />
                      </b-button>
                    </div>
                    <small
                      v-if="a.isUploadDisabledByTeam(card.key)"
                      class="text-danger d-block mt-1"
                    >يجب اضافة الفريق اولا</small>
                  </div>
                  <!-- Notes Section -->
                  <div
                    v-if="card.file"
                    class="media-card-notes w-100 mt-2"
                  >
                    <div
                      v-if="!a.editingNotes[card.file.id]"
                      class="notes-display"
                    >
                      <div
                        v-if="card.file.notes"
                        class="notes-content"
                      >
                        <p class="notes-text mb-0">
                          {{ card.file.notes }}
                        </p>
                      </div>
                    </div>
                    <div
                      v-else
                      class="notes-edit"
                    >
                      <b-form-textarea
                        v-model="a.notesEdit[card.file.id]"
                        placeholder="أدخل الملاحظات..."
                        rows="3"
                        class="mb-1"
                        :disabled="a.savingNotes[card.file.id]"
                      />
                      <div class="d-flex gap-1">
                        <b-button
                          size="sm"
                          variant="primary"
                          class="flex-fill"
                          :disabled="a.savingNotes[card.file.id]"
                          @click="a.saveNote(card.file)"
                        >
                          <b-spinner
                            v-if="a.savingNotes[card.file.id]"
                            small
                            class="mr-1"
                          />
                          حفظ
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          class="flex-fill"
                          :disabled="a.savingNotes[card.file.id]"
                          @click="a.cancelEditingNote(card.file.id)"
                        >
                          إلغاء
                        </b-button>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="card.file"
                    class="media-card-actions d-flex flex-row justify-content-center gap-1 w-100"
                  >
                    <b-button
                      v-if="card.file.is_image || card.file.is_video || card.file.is_document"
                      v-b-tooltip.hover.top="'معاينة'"
                      :href="card.file.url"
                      target="_blank"
                      size="sm"
                      class="btnSM"
                      variant="info"
                    >
                      <feather-icon
                        icon="EyeIcon"
                        size="12"
                      />
                    </b-button>
                    <b-button
                      v-if="a.hasPermission('download media')"
                      v-b-tooltip.hover.top="'تحميل'"
                      :href="card.file.download_url"
                      target="_blank"
                      size="sm"
                      class="btnSM"
                      variant="success"
                    >
                      <feather-icon
                        icon="DownloadIcon"
                        size="12"
                      />
                    </b-button>
                    <b-button
                      v-if="card.file.download_PDF_url && a.hasPermission('download media')"
                      v-b-tooltip.hover.top="'PDF تحميل'"
                      :href="card.file.download_PDF_url"
                      target="_blank"
                      size="sm"
                      class="btnSM"
                      variant="primary"
                    >
                      <feather-icon
                        icon="DownloadCloudIcon"
                        size="12"
                      />
                    </b-button>
                    <b-button
                      v-if="a.hasPermission('delete media')"
                      v-b-tooltip.hover.top="'حذف'"
                      size="sm"
                      class="btnSM"
                      variant="danger"
                      @click="a.deleteFile(card.file.id)"
                    >
                      <feather-icon
                        icon="Trash2Icon"
                        size="12"
                      />
                    </b-button>
                    <b-button
                      v-if="!a.editingNotes[card.file.id] && a.hasPermission('edit projects')"
                      v-b-tooltip.hover.top="card.file.notes ? 'تعديل الملاحظات' : 'إضافة ملاحظات'"
                      size="sm"
                      class="btnSM"
                      variant="outline-secondary"
                      @click="a.startEditingNote(card.file)"
                    >
                      <feather-icon
                        icon="EditIcon"
                        size="12"
                      />
                    </b-button>
                  </div>
                </b-card>
              </template>
            </div>
            <ProjectNoteEditor
              :project-id="a.projectId"
              group="attachments_block7"
              label="ملاحظات مساعد المساح"
              class="mb-2"
            />
          </b-collapse>
          <b-button
            class="attachments-block-collapse-toggle-btn"
            variant="light"
            size="sm"
            @click="a.show_attachments_block7 = !a.show_attachments_block7"
            v-b-tooltip.hover.top="a.show_attachments_block7 ? 'إخفاء' : 'إظهار'"
          >
            <feather-icon
              :icon="a.show_attachments_block7 ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              size="16"
              class="mr-25"
            />
          </b-button>
        </div>
</template>

<script>
import attachmentsBlockMixin from '../attachmentsBlockMixin'

export default {
  name: 'AttachmentsBlock7',
  mixins: [attachmentsBlockMixin],
}
</script>

<style src="../attachments-shared.scss" lang="scss"></style>
